// extracted by mini-css-extract-plugin
module.exports = {"container":"_1yjk172RROC3UiABuXKe3G","cancelBtn":"_1vbFAfvJVyVZcfJcqxfRpM","icon":"RJ1XMtSXjdxzXhS2oY_4A","saveBtn":"_1NiTSEscs2qZpW6TYandMf"};